import './css/App.css';
import React, {useEffect, useRef, useState} from "react";
import {loadingAtom} from "./atoms";
import {useRecoilState} from 'recoil';
import Loading from "./core/Loading";
import Cookies from "js-cookie";
import {useLocation, useNavigate} from "react-router-dom";
import {getCompanyByUserUUID, userUUIDExists} from "./utils/requestUtils";
import {clearCurrentSession, ensureSessionIsActive, logoutAndRedirect, renewActiveSession} from "./utils/session";
import {downloadSbPrinter} from "./utils/sbPrinterDownload";


function Menu({children}) {

    const [currentLoading, setCurrentLoading] = useRecoilState(loadingAtom);

    const [activeMenu, setActiveMenu] = useState(null);
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const checkIfUserIsLogged = () => {
        userUUIDExists().catch(r => {
            if (r.statusCode === 404) {
                navigate('/login');
            }
        });
    }

    const handleMenuClick = (menu) => {
        checkIfUserIsLogged();
        if (activeMenu === menu && isMenuVisible) {
            setMenuVisible(false);
            setActiveMenu(null);
        } else {
            setActiveMenu(menu);
            if (menu === 'Cadastrar' || menu === 'Consultar' || menu === 'Cliente' || menu === 'Produto' || menu === 'Pedido' || menu === 'Financeiro' || menu === 'Entrada' || menu === 'Mesa' || menu === 'Comanda' || menu === 'Usuário' || menu === 'Empresas' || menu === 'Caixa' || menu === 'Formas de Pagamento') {
                setMenuVisible(true);
            } else {
                setMenuVisible(false);
            }
        }
    };


    const [isMenuVisible, setMenuVisible] = useState(false);
    const menuRef = useRef(null);


    const [companyName, setCompanyName] = useState(null);
    // Mesma regra dos atalhos da tela inicial: só esconde quando a empresa desabilitou.
    const [showCounterOrder, setShowCounterOrder] = useState(true);
    const [showTableOrder, setShowTableOrder] = useState(true);
    const [showComandaOrder, setShowComandaOrder] = useState(false);
    const [showCustomerMenu, setShowCustomerMenu] = useState(false);
    const [deliveryEnabled, setDeliveryEnabled] = useState(false);
    useEffect(() => {

        async function fetchData() {
            try {
                const result = await getCompanyByUserUUID();
                setCompanyName(result.name);
                setShowCounterOrder(result.showCounterOrder !== false);
                setShowTableOrder(result.showTableOrder !== false);
                setShowComandaOrder(!!result.showComandaOrder);
                setShowCustomerMenu(!!result.showCustomerMenu);
                setDeliveryEnabled(!!result.deliveryEnabled);
            } catch (error) {
                console.error('Erro ao buscar os dados:', error);
            }
        }

        fetchData();

        const handleOutsideClick = (event) => {
            // Se o clique não foi dentro do menu, oculta o menu
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuVisible(false);
                setDrawerOpen(false);
            }
        };

        // Adiciona um ouvinte de evento global para cliques fora do menu
        document.addEventListener('click', handleOutsideClick);

        // Remove o ouvinte de evento quando o componente é desmontado
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []); // Executa apenas uma vez durante a montagem do componente

    // Fecha a gaveta/menu automaticamente sempre que a rota muda.
    useEffect(() => {
        setDrawerOpen(false);
        setMenuVisible(false);
        setActiveMenu(null);
    }, [location.pathname]);

    const toggleMenu = () => {
        setMenuVisible(!isMenuVisible);
    };

    const toggleDrawer = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDrawerOpen((prev) => !prev);
    };

    function handleExitClickButton() {
        clearCurrentSession();
        navigate('/login');
    }

    const navigateWithSessionCheck = (path, shouldReload = false) => {
        if (!ensureSessionIsActive()) {
            logoutAndRedirect();
            return;
        }
        renewActiveSession();
        navigate(path);
        if (shouldReload) {
            window.location.reload();
        }
    };

    // Verifica o tipo de usuário e nome para exibir no cabeçalho
    const userCookies = Cookies.get('user');
    let userType = 0; // BASIC por padrão
    let userDisplayName = '';
    if (userCookies) {
        try {
            const user = JSON.parse(userCookies);
            userType = user.userType !== undefined ? user.userType : 0;
            const n = user.name != null ? String(user.name).trim() : '';
            const em = user.email != null ? String(user.email).trim() : '';
            userDisplayName = n || em;
        } catch (error) {
            console.error('Erro ao ler dados do usuário:', error);
        }
    }

    // Constantes de tipo de usuário (deve corresponder ao backend)
    const BASIC = 0;
    const INTERMEDIATE = 1;
    const ADMIN = 2;

    const isBasicUser = userType === BASIC;
    const isIntermediateUser = userType === INTERMEDIATE;
    const isAdminUser = userType === ADMIN;

    const headerTitle =
        userDisplayName && companyName
            ? `${companyName} · ${userDisplayName}`
            : companyName || userDisplayName || null;

    return (
        <div>
            {currentLoading && (<Loading/>)}

            <div className="app-header">
                <button
                    type="button"
                    className="icon-btn"
                    aria-label={isDrawerOpen ? 'Fechar menu' : 'Abrir menu'}
                    onClick={toggleDrawer}
                >
                    <span className={'hamburger ' + (isDrawerOpen ? 'open' : '')}>
                        <span/><span/><span/>
                    </span>
                </button>

                <button
                    type="button"
                    className="icon-btn"
                    aria-label="Início"
                    onClick={(e) => {
                        e.preventDefault();
                        setMenuVisible(false);
                        setDrawerOpen(false);
                        navigate('/app');
                    }}
                >
                    <svg className="home-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 3 2 12h3v8h5v-6h4v6h5v-8h3L12 3z"/>
                    </svg>
                </button>

                <div className="app-header-title">{headerTitle}</div>

                <button type="button" className="logout-btn" onClick={handleExitClickButton}>
                    Sair
                </button>
            </div>

            {isDrawerOpen && (
                <div className="drawer-backdrop" onClick={() => setDrawerOpen(false)}/>
            )}

            <div ref={menuRef} className={'nav-drawer ' + (isDrawerOpen ? 'open' : '')}>
                <div className="nav-drawer-header">
                    <strong>{headerTitle || 'Menu'}</strong>
                    <button
                        type="button"
                        className="icon-btn"
                        aria-label="Fechar menu"
                        onClick={() => setDrawerOpen(false)}
                    >
                        <span className="hamburger open"><span/><span/><span/></span>
                    </button>
                </div>

                <ul className="nav-list">
                    {(isAdminUser || isIntermediateUser) && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Mesa');
                                }}
                                className={'nav-link ' + (activeMenu === 'Mesa' && isMenuVisible ? 'active' : '')}
                            >
                                Mesa
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Mesa' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/tablelist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Mesa
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/table');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Mesa
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {/* Comanda (cadastro de clientes) - ADMIN sempre; INTERMEDIATE se a empresa habilitou Pedido Comanda */}
                    {(isAdminUser || (isIntermediateUser && showComandaOrder)) && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Comanda');
                                }}
                                className={'nav-link ' + (activeMenu === 'Comanda' && isMenuVisible ? 'active' : '')}
                            >
                                Comanda
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Comanda' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/customerlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Comanda
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/customer');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Comanda
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {/* Cliente (clientes de Take Away/Delivery) - ADMIN e INTERMEDIATE, se a empresa habilitou o cadastro */}
                    {(isAdminUser || isIntermediateUser) && showCustomerMenu && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Cliente');
                                }}
                                className={'nav-link ' + (activeMenu === 'Cliente' && isMenuVisible ? 'active' : '')}
                            >
                                Cliente
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Cliente' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/walkin-customerlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Cliente
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/walkin-customer');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Cliente
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {(isAdminUser || isIntermediateUser) && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Produto');
                                }}
                                className={'nav-link ' + (activeMenu === 'Produto' && isMenuVisible ? 'active' : '')}
                            >
                                Produto
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Produto' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/productlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Produto
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/product');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Produto
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/categorylist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Categoria
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/category');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Categoria
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {(isAdminUser || isIntermediateUser) && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Formas de Pagamento');
                                }}
                                className={'nav-link ' + (activeMenu === 'Formas de Pagamento' && isMenuVisible ? 'active' : '')}
                            >
                                Formas de Pagamento
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Formas de Pagamento' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/paymentmethodlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Forma de Pagamento
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/paymentmethod');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Forma de Pagamento
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    <li>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu();
                                handleMenuClick('Pedido');
                            }}
                            className={'nav-link ' + (activeMenu === 'Pedido' && isMenuVisible ? 'active' : '')}
                        >
                            Pedido
                            <span className="nav-chevron">▶</span>
                        </button>
                        {isMenuVisible && activeMenu === 'Pedido' && (
                            <ul className="nav-submenu">
                                {/* Pedido Mesa - visível para todos, se habilitado na empresa */}
                                {showTableOrder && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                localStorage.removeItem('sale');
                                                navigateWithSessionCheck('/sale/table');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Pedido Mesa
                                        </button>
                                    </li>
                                )}

                                {/* Pedido Comanda - visível para todos, se habilitado na empresa */}
                                {showComandaOrder && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                localStorage.removeItem('sale');
                                                navigateWithSessionCheck('/sale/table-comanda');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Pedido Comanda
                                        </button>
                                    </li>
                                )}

                                {/* Pedido Take Away - visível para todos */}
                                <li>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            localStorage.removeItem('sale');
                                            navigateWithSessionCheck('/sale/takeaway');
                                            setMenuVisible(false);
                                        }}
                                        className="nav-sublink"
                                    >
                                        Pedido Take Away
                                    </button>
                                </li>

                                {/* Pedido Balcão - para INTERMEDIATE e ADMIN, se habilitado na empresa */}
                                {(isIntermediateUser || isAdminUser) && showCounterOrder && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                localStorage.removeItem('sale');
                                                navigateWithSessionCheck('/sale/items', true);
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Pedido Balcão
                                        </button>
                                    </li>
                                )}

                                {/* Pedido Delivery - para INTERMEDIATE e ADMIN, se a empresa tiver entrega habilitada */}
                                {(isIntermediateUser || isAdminUser) && deliveryEnabled && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                localStorage.removeItem('sale');
                                                navigateWithSessionCheck('/sale/delivery-customer');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Pedido Delivery
                                        </button>
                                    </li>
                                )}

                                {/* Fechar Pedidos - para INTERMEDIATE e ADMIN */}
                                {(isIntermediateUser || isAdminUser) && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/sale/orders-pending');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Fechar Pedidos
                                        </button>
                                    </li>
                                )}

                                {/* Reimprimir - somente ADMIN */}
                                {isAdminUser && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/sale/print');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Reimprimir
                                        </button>
                                    </li>
                                )}

                                {/* Consultar Pedidos - para INTERMEDIATE e ADMIN */}
                                {(isIntermediateUser || isAdminUser) && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/sale/sales');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Pedidos
                                        </button>
                                    </li>
                                )}

                                {/* Produtos Vendidos - ADMIN e INTERMEDIATE */}
                                {(isAdminUser || isIntermediateUser) && (
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/sale/sales_items');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Produtos Vendidos
                                        </button>
                                    </li>
                                )}
                            </ul>
                        )}
                    </li>

                    {(isAdminUser || isIntermediateUser) && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Caixa');
                                }}
                                className={'nav-link ' + (activeMenu === 'Caixa' && isMenuVisible ? 'active' : '')}
                            >
                                Caixa
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Caixa' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/cashregister');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Abrir/Fechar Caixa
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/cashregisterlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Histórico de Caixa
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {isAdminUser && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Usuário');
                                }}
                                className={'nav-link ' + (activeMenu === 'Usuário' && isMenuVisible ? 'active' : '')}
                            >
                                Usuário
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Usuário' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/userlist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/user');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {isAdminUser && (
                        <li>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu();
                                    handleMenuClick('Empresas');
                                }}
                                className={'nav-link ' + (activeMenu === 'Empresas' && isMenuVisible ? 'active' : '')}
                            >
                                Empresas
                                <span className="nav-chevron">▶</span>
                            </button>
                            {isMenuVisible && activeMenu === 'Empresas' && (
                                <ul className="nav-submenu">
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/companylist');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Consultar Empresas
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                navigate('/company');
                                                setMenuVisible(false);
                                            }}
                                            className="nav-sublink"
                                        >
                                            Cadastrar Empresa
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </li>
                    )}

                    {(isAdminUser || isIntermediateUser) && (
                        <li>
                            <button
                                type="button"
                                onClick={async () => {
                                    setDrawerOpen(false);
                                    setCurrentLoading(true);
                                    try {
                                        await downloadSbPrinter();
                                    } catch (error) {
                                        console.error('Error downloading sb-printer:', error);
                                        alert('Erro ao baixar o SB Printer: ' + error.message);
                                    } finally {
                                        setCurrentLoading(false);
                                    }
                                }}
                                className="nav-link"
                            >
                                Baixar SB Printer
                            </button>
                        </li>
                    )}
                </ul>
            </div>

            {children}
        </div>
    );
}

export default Menu;
